import React from 'react';
import { 
  Paper, 
  Stack, 
  Box, 
  Typography, 
  Button, 
  Alert 
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { AIChatMessage } from '@personal-dashboard/ui';

interface Message {
  id: string;
  sender: string;
  content: string;
  createdAt: string;
}

interface PastLesson {
  id: string;
  title: string;
  summary?: string;
  createdAt: string;
  messages: Message[];
}

interface PastLessonViewerProps {
  selectedPastLesson: PastLesson;
  onClose: () => void;
}

const PastLessonViewer: React.FC<PastLessonViewerProps> = ({
  selectedPastLesson,
  onClose
}) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        borderRadius: 3,
        border: '1px solid',
        borderColor: 'divider',
        height: 550,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'background.paper',
      }}
    >
      {/* Past Lesson Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ pb: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {selectedPastLesson.title}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Completed on {new Date(parseInt(selectedPastLesson.createdAt)).toLocaleString()}
          </Typography>
        </Box>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ textTransform: 'none', borderRadius: 2 }}
        >
          Close History
        </Button>
      </Stack>

      {/* Past Lesson Summary Panel */}
      <Box sx={{ py: 2 }}>
        <Alert icon={<HelpOutlineIcon />} severity="info" sx={{ '& .MuiAlert-message': { width: '100%' } }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 0.5 }}>
            Lesson Summary
          </Typography>
          <Typography variant="body2">
            {selectedPastLesson.summary || "No summary saved for this lesson."}
          </Typography>
        </Alert>
      </Box>

      {/* Past Lesson Conversation log */}
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
        Conversation Transcript:
      </Typography>
      <Box sx={{ flexGrow: 1, overflowY: 'auto', py: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>
        {selectedPastLesson.messages && selectedPastLesson.messages.length > 0 ? (
          selectedPastLesson.messages.map((message) => (
            <AIChatMessage
              key={message.id}
              sender={message.sender}
              content={message.content}
              senderName={message.sender === 'assistant' ? 'Sven' : 'You'}
            />
          ))
        ) : (
          <Typography variant="body2" color="text.secondary">
            No conversation logs available for this session.
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default PastLessonViewer;
